export default __webpack_public_path__ + "static/media/r_wdt_c_0_1.f9cf7eaa.mp3";